import React, { useContext, useEffect } from "react";

//styling
import "../../Styles/MainPage.scss";

//global state
import { StateContext } from "../../AppStateContext";

//fade in effect
import FadeIn from "react-fade-in";

const WeaviateErrorPage = ({ text }) => {
  //global state
  const state = useContext(StateContext);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <FadeIn transitionDuration={1000} className="__fadeIn">
      <div className="__WeaviateErrorPage">
        <h1
          className={
            state.theme === "dark"
              ? "__weaviateErrorPageHeaderDark"
              : "__weaviateErrorPageHeaderLight"
          }
        >
          {text
            ? text
            : "Oops... looks like you aren't connected to a Weaviate instance. Please reconnect."}
        </h1>
      </div>
    </FadeIn>
  );
};

export default WeaviateErrorPage;
